// extracted by mini-css-extract-plugin
module.exports = {"root":"tweet-body_root__ChzUj"};